function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.7 283.7"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M248.3 0h28.3v56.7h-28.3V0zm14.2 63.7c3.4-.2 6.8.7 9.8 2.4 5.4 3.2 8.3 9.6 7.8 16.8-.7 10.4-7.5 15.7-16.2 16.2-2.8.2-5.6-.1-8.3-1-6-2.2-9.7-6.5-10.6-13.4-.8-5.7.1-11 3.8-15.4 3.3-3.9 7.7-5.3 12.4-5.5.4-.1.8-.1 1.3-.1zM141.8 78.2v63.6h63.6v49.7h-63.6V255H92.5v-63.4h-64v-49.7h64V78.2h49.3m28.5-28.5H64v63.6H0V220h64v63.4h106.4V220H234V113.3h-63.6l-.1-63.6z"
})));